import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-38d2767a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "userLoginPage" }
const _hoisted_2 = { style: {"display":"flex","width":"100%","align-items":"center","justify-content":"center","margin-top":"20px"} }

import { ref } from "vue";
import API from "@/api";
import {
  getRegisterCodeUsingGet,
  userRegisterUsingPost,
} from "@/api/userController";
import { useLoginUserStore } from "@/store/userStore";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import UserRetryPasswordModal from "@/views/user/components/UserRetryPasswordModal.vue";

const countDownInit = 60;

export default /*#__PURE__*/_defineComponent({
  __name: 'UserRegisterPage',
  setup(__props) {

const router = useRouter();
const loginUserStore = useLoginUserStore();

const countDown = ref(countDownInit);
const loading = ref(false);

const form = ref<API.UserRegisterRequest>({});

const sendCode = async () => {
  if (!form.value.userEmail) {
    message.error("请输入邮箱");
    return;
  }
  const res = await getRegisterCodeUsingGet({
    email: form.value.userEmail,
  });
  if (res.data.code === 200) {
    countDown.value = countDownInit;
    loading.value = true;
    var timer = setInterval(() => {
      countDown.value--;
      if (countDown.value == 0) {
        clearInterval(timer);
        loading.value = false;
      }
    }, 1000);
    message.success("发送验证码成功，请在邮箱中查看");
  } else {
    message.error("发送验证码失败，" + res.data.message);
  }
};

const handleSubmit = async () => {
  const res = await userRegisterUsingPost(form.value);
  if (res.data.code === 200) {
    await loginUserStore.fetchLoginUser();
    message.success("注册成功");
    router.push({
      path: "/user/login",
      replace: true,
    });
  } else {
    message.error("注册失败，" + res.data.message);
  }
};
const userRetryPasswordModal = ref();

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_typography_title, { heading: 2 }, {
      default: _withCtx(() => [
        _createTextVNode(" 用户注册 ")
      ]),
      _: 1
    }),
    _createVNode(_component_a_form, {
      model: form.value,
      style: { width: '480px', margin: '0 auto' },
      "label-align": "left",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "账号",
          "validate-trigger": "input",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userAccount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.userAccount) = $event)),
              placeholder: "请输入长度大于等于4的账号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "密码",
          "validate-trigger": "input",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.value.userPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.userPassword) = $event)),
              placeholder: "请输入长度大于等于6的密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "确认密码",
          "validate-trigger": "input",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.value.checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.checkPassword) = $event)),
              placeholder: "请输入长度大于等于6的密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "昵称",
          "validate-trigger": "input",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.userName) = $event)),
              placeholder: "请输入昵称..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "邮箱",
          "validate-trigger": "input",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userEmail,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.userEmail) = $event)),
              placeholder: "请输入邮箱..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "验证码",
          "validate-trigger": "input",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.code,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.code) = $event)),
              placeholder: "请输入验证码..."
            }, {
              append: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: sendCode,
                  loading: loading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(loading.value ? `${countDown.value}` + "后重试" : "发送验证码"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "primary",
            "html-type": "submit",
            style: {"width":"120px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("注册")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_space, { style: {"display":"flex","width":"100%","align-items":"center","justify-content":"center","margin-top":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_link, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (userRetryPasswordModal.value.openModal()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("找回密码")
              ]),
              _: 1
            }),
            _createVNode(_component_a_link, { href: "/user/login" }, {
              default: _withCtx(() => [
                _createTextVNode("用户登录")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(UserRetryPasswordModal, {
          ref_key: "userRetryPasswordModal",
          ref: userRetryPasswordModal
        }, null, 512)
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})